<template>
  <div class="card shadow" v-on:click="select">
    <img v-if="domain.logo" :src="domain.logo" class="images" :alt="domain.tenantName || domain.domain">
    <div v-else class="fallback-icon"><i class="fa fa-building"></i></div>
    <div class="card-text">
      <span>{{ domain.tenantName || domain.name }}</span>
      <span>{{ domain.domain }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "domain"
  ],
  methods: {
    select() {
      this.$emit("selectDomain", this.domain.domain);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 180px;
  padding: .5em;
  border: 1px solid #d8cebf;
  border-radius: var(--radius-md);
  text-align: center;
  margin: 0;
  transition: border-color 0.15s, background 0.15s;
  box-sizing: border-box;
  cursor: pointer;
  background: #fffdf8;
  color: #1b1712;

  img,
  .fallback-icon {
    padding: .25em;
    max-width: 90%;
    max-height: 70%;
    object-fit: scale-down;
    margin: 0 auto;
  }

  .fallback-icon {
    font-size: 2.5rem;
    color: #6f5729;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
  }

  .card-text {
    span:first-child {
      font-size: 1.15em;
      overflow: hidden;
      font-weight: 600;
    }
    span:nth-child(2)::before {
      white-space: pre;
      content: "\A";
    }
    span:nth-child(2) {
      border-top: 1px solid lightgray;
      font-style: italic;
      color: #8a8a8a;
      font-size: 0.85em;
    }
  }
}

.card:hover {
  border-color: #1b1712;
  background: #faf6ef;
  box-shadow: none;
}
</style>
